<template>
  <v-btn v-if="$device.isDesktop" class="h-100" width="100px" id="parent">
    <template #default>
      <v-sheet class="d-flex flex-column align-center">
        <v-avatar size="36">
          <CountryFlag size="big" :country="languageStore.currentLanguage?.country"/>
        </v-avatar>
        <span class="d-inline-block text-caption text-truncate mt-0" style="max-width: 100px">{{
            languageStore.currentLanguage?.label
          }}</span>
      </v-sheet>
    </template>
  </v-btn>
  <v-list-item v-else id="parent">
    <v-sheet class="d-flex flex-row align-center w-100">
      <v-icon icon="mdi-menu-left" class="mr-2" size="x-small"></v-icon>
      <v-avatar style="width: 28px; height: 28px">
        <CountryFlag size="big" :country="languageStore.currentLanguage?.country"/>
      </v-avatar>
      <v-chip variant="text" :text="languageStore.currentLanguage?.label"
              class="text-subtitle-2"/>
    </v-sheet>
  </v-list-item>
  <v-menu activator="#parent" :submenu="$device.isMobile" :location="$device.isMobile?'left':'bottom center'">
    <v-sheet class="d-flex flex-column align-center bg-transparent px-4" elevation="0">
      <v-icon v-if="$device.isDesktop" icon="mdi-transfer-up" size="48" color="primary"/>
      <v-sheet :style="$device.isDesktop?'position: relative; top: -30px;':''" rounded
               elevation=8>
        <v-sheet color="primary" class="d-flex justify-center align-center rounded-t px-4 py-2">
        <span class="text-subtitle-1 font-weight-bold justify-center text-uppercase font-italic">
          {{ t('select-language') }}
        </span>
        </v-sheet>
        <v-list @update:selected="onSelectedLanguage" density="compact">
          <template v-for="(language,idx) in languages" :key="language.id">
            <v-list-item :value="language" :v-if="userStore.isAdmin || language.available">
              <template #title>
                <v-sheet class="d-flex flex-row align-center py-2">
                  <CountryFlag :country="language.country" rounded style="position: relative;top: -5px"/>
                  <span class="text-subtitle-1 ml-2 me-auto">{{ language.label }}</span>
                  <v-sheet v-if="userStore.isAdmin" class="d-flex align-center ml-2" width="70">
                    <v-progress-circular :color="color(language)" size="24" width="3"
                                         :model-value="percentage(language)"
                                         class="mr-1"/>
                    <span :class="`text-${color(language)}`" class="font-weight-bold">
              {{ percentage(language) }}%
                </span>
                  </v-sheet>
                </v-sheet>
              </template>
            </v-list-item>
            <v-divider v-if="idx<languages.length-1" class="mx-4"></v-divider>
          </template>
        </v-list>
      </v-sheet>
    </v-sheet>
  </v-menu>
</template>

<script setup lang="ts">
import type {Language} from "~/types/language";
import {useI18n} from "vue-i18n";
import {useAdminDrawerStore} from "~/stores/admin/drawer";

const {languages} = defineProps<{
  languages: Language[]
}>()

const {t} = useI18n()
const languageStore = useLanguageStore()
const decathStore = useDecathlonStores()
const userStore = useUserStore()
const adminDrawerStore = useAdminDrawerStore()

const onSelectedLanguage = async (currentLanguage: Language[]) => {
  languageStore.currentLanguage = currentLanguage[0]
  await refreshNuxtData()
  languageStore.currentLanguage = languageStore.findLanguage(currentLanguage[0].id)
}

const percentage = (language: Language) => {
  if (language.translatedItems === 0) return 0;

  const raw = (language.translatedItems / language.totalItems) * 100;
  const rounded = Math.round(raw);

  if (raw > 0 && raw < 1) return 1;
  if (raw > 99 && raw < 100) return 99;
  if (raw > 98 && raw < 99) return 98;

  return rounded;
};


const color = (language: Language) => {
  const ratio = percentage(language)
  if (ratio === 0) return 'gray'
  return ratio === 100 ? 'completed' : 'not-completed'
}
</script>
<style scoped>
.v-menu > .v-overlay__content > .v-list {
  border-radius: 4px;
  background: #FFF;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);
}

.big-flag {
  transform: scale(.97);
  margin-right: -13px;
  margin-left: -13px;
}
</style>

<!--v-sheet class="d-flex flex-row align-center" style="top: -9%; left: -8%;bottom: -5%"-->
